export const debounce =
  (callback, delay = 250, interval) =>
  (...args) =>
    clearTimeout(interval, (interval = setTimeout(callback, delay, ...args)));

export const conditionalDebounce = (callback, delay) =>
  delay > 0 ? debounce(callback, delay) : callback;
